import { passkeyClient } from "@better-auth/passkey/client";
import { createAuthClient } from "better-auth/client";
import {
  adminClient,
  jwtClient,
  oneTimeTokenClient,
  usernameClient,
} from "better-auth/client/plugins";

export function makeBetterAuthClient(baseURL: string, http: typeof fetch) {
  return createAuthClient({
    baseURL,
    basePath: "/auth/v2",
    fetchOptions: {
      credentials: "include",
      customFetchImpl: http,
    },
    plugins: [
      usernameClient({ displayUsername: false }),
      adminClient(),
      jwtClient(),
      passkeyClient(),
      oneTimeTokenClient(),
    ],
  });
}

export type BetterAuthClient = ReturnType<typeof makeBetterAuthClient>;
